import axios from "axios";
import axiosRetry from "axios-retry";
import { strings } from "../Strings";

/**
 * WebAPI基底クラス
 *
 * @class BaseApi
 */
class BaseApi {
  /**
   * デフォルトのHTTPリクエスト設定を定義します。
   *
   * @constant {Object}
   * @memberof BaseApi
   */
  DEFAULT_REQUEST_CONFIG = {
    // baseURL: process.env.REACT_APP_API_BASE_URL,
    // timeout: process.env.REACT_APP_API_TIMEOUT,
    // baseURL: 'https://luckland.dev.cpoint-lab.co.jp:444/api',
    // baseURL: `${window.location.origin}/account-browser-api`,
    baseURL: "http://localhost:3003/",
    timeout: 30000,
  };

  /**
   * コンストラクタです。
   *
   * @param {AuthenticationService} [authenticationService=null] 認証サービス
   * @memberof BaseApi
   */
  constructor(authenticationService = null) {
    this._authenticationService = authenticationService;
  }

  /**
   * 認証サービスを返却します。
   *
   * @readonly
   * @memberof BaseApi
   */
  get authenticationService() {
    return this._authenticationService;
  }

  /**
   * HTTPリクエストオブジェクトを生成します。
   *
   * @param {Object} [additionalRequestConfig={}] 追加のHTTPリクエスト設定
   * @return {AxiosInstance} Axiosインスタンス
   * @memberof BaseApi
   */
  createRequest(additionalRequestConfig = {}) {
    const client = axios.create({
      ...this.DEFAULT_REQUEST_CONFIG,
      ...additionalRequestConfig,
    });
    axiosRetry(client, { retries: strings.API_RETRY_COUNT });
    return client;
  }
}

export default BaseApi;
